import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { removeItem, } from '@tymia/shared';
import { useDeferredValue, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import { ArrowDropDownIcon, } from '../icons/ArrowDropDownIcon.js';
import { ArrowDropUpIcon, } from '../icons/ArrowDropUpIcon.js';
const selectedValues = {};
const listeners = {};
function toggleSelectedValue(group, value) {
    setSelectedValue(group, selectedValues[group] === value ? null : value);
}
function setSelectedValue(group, value) {
    selectedValues[group] = value;
    listeners[group]?.forEach(listener => listener(value));
}
function subscribe(group, listener) {
    const list = listeners[group] ?? [];
    listeners[group] = list;
    list.push(listener);
    listener(selectedValues[group] ?? null);
    return () => removeItem(list, listener);
}
function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
export function FilterItemGroup({ group, label, labelClass, children, }) {
    const [checked, setChecked] = useState(false);
    // the child component is removed too fast, so no callbacks are fired.
    // Therefore, delay the removal of the child component
    const checkedDeferred = useDeferredValue(checked);
    const anchorRef = useRef(null);
    const popoverRef = useRef(null);
    useEffect(() => {
        const unsubscribe = subscribe(group, value => setChecked(value === label));
        return unsubscribe;
    }, [group, label]);
    function close() {
        setSelectedValue(group, null);
    }
    useLayoutEffect(() => {
        if (!checkedDeferred || !anchorRef.current || !popoverRef.current) {
            return;
        }
        function updatePosition() {
            if (!checkedDeferred || !anchorRef.current || !popoverRef.current) {
                return;
            }
            const anchorRect = anchorRef.current.getBoundingClientRect();
            const popRect = popoverRef.current.getBoundingClientRect();
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const top = anchorRect.bottom + 8;
            let left = anchorRect.left;
            if (left + popRect.width > vw - 8) {
                left = anchorRect.right - popRect.width;
            }
            left = clamp(left, 8, vw - popRect.width - 8);
            const maxTop = vh - popRect.height - 8;
            const minTop = anchorRect.bottom + 8;
            const finalTop = clamp(top, minTop, Math.max(minTop, maxTop));
            popoverRef.current.style.left = `${left}px`;
            popoverRef.current.style.top = `${finalTop}px`;
            popoverRef.current.style.visibility = 'visible';
        }
        updatePosition();
        const ro = new ResizeObserver(updatePosition);
        ro.observe(anchorRef.current);
        ro.observe(document.documentElement);
        window.addEventListener('resize', updatePosition);
        window.addEventListener('scroll', updatePosition, true);
        return () => {
            ro.disconnect();
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, true);
        };
    }, [checkedDeferred]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: anchorRef, className: "inline-block", onClick: () => toggleSelectedValue(group, label), children: _jsxs("label", { className: labelClass, children: [label, checked
                            ? _jsx(ArrowDropUpIcon, { size: 24, className: "fill-tym-green" })
                            : _jsx(ArrowDropDownIcon, { size: 24, className: "fill-tym-green" })] }) }), checkedDeferred && (_jsx("div", { ref: popoverRef, className: "filterpoints md:fixed content z-80 md:border md:shadow-sm p-1.5 pb-0 max-md:px-0 md:w-112.5 md:max-h-87.5 overflow-y-auto bg-white", style: {
                    left: '-9999px',
                    top: '-9999px',
                    visibility: 'hidden',
                }, children: children({ close }) }))] }));
}
//# sourceMappingURL=FilterItemGroup.js.map